import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarTrends = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 471,
	height: 230,
	viewBox: "0 0 471 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 167,
			y: 107,
			width: 52,
			height: 123,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 251,
			y: 46,
			width: 52,
			height: 184,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 419,
			y: 46,
			width: 52,
			height: 184,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 335,
			width: 52,
			height: 230,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 73,
			width: 52,
			height: 157,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84,
			y: 107,
			width: 52,
			height: 123,
			fill: "#C4C4C4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 173,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 110,
			cy: 185,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 193,
			cy: 173,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 277,
			cy: 147,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 362,
			cy: 107,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 445,
			cy: 131,
			r: 5,
			fill: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.0707,
			y1: 172.505,
			x2: 110.071,
			y2: 184.505,
			stroke: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 193.072,
			y1: 173.495,
			x2: 110.072,
			y2: 185.495,
			stroke: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 277.143,
			y1: 147.479,
			x2: 190.143,
			y2: 173.479,
			stroke: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 361.215,
			y1: 107.451,
			x2: 277.215,
			y2: 147.451,
			stroke: "#7F7E7E"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 361.137,
			y1: 106.519,
			x2: 445.137,
			y2: 130.519,
			stroke: "#7F7E7E"
		})
	]
});
export default SvgBarTrends;
